import { render, staticRenderFns } from "./radio-box.vue?vue&type=template&id=25bb97ec&scoped=true"
import script from "./radio-box.vue?vue&type=script&lang=js"
export * from "./radio-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb97ec",
  null
  
)

export default component.exports